/** Auth channel: embed tokens (Wix/Radical) vs hospital CRE (CIAM). */
export const AUTH_SOURCE = {
  WIX: "WIX",
  RADICAL: "RADICAL",
  CRE: "CRE",
};

export function isCreAuthSource(source) {
  return source === AUTH_SOURCE.CRE;
}

/** Wix and CRE load study via Reporting `GetUserStudy`. */
export function usesReportingGetUserStudy(source) {
  return source === AUTH_SOURCE.WIX || source === AUTH_SOURCE.CRE;
}

export function authSourceFromSystemCode(systemCode) {
  if (!systemCode) return null;
  const code = String(systemCode).toUpperCase();
  if (code === AUTH_SOURCE.RADICAL) return AUTH_SOURCE.RADICAL;
  if (code === AUTH_SOURCE.CRE || code === "ENTERPRISE") return AUTH_SOURCE.CRE;
  if (code === AUTH_SOURCE.WIX) return AUTH_SOURCE.WIX;
  return null;
}

/** Lowercase provider id for report-engine / extension integrations. */
export function integrationAuthProvider(authSource) {
  if (authSource === AUTH_SOURCE.CRE) return "cre";
  if (authSource === AUTH_SOURCE.WIX) return "wix";
  return "radical";
}
